<template>
<div class="card">
    <div class="card-header">HR Audit</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
        <BaseStatusHelp lifecycleStatus="06"/>
        <b-row v-if="isUnderReview">
            <b-col>
                <b-alert show>This audit has been submitted for HRM Supervisor review. Please wait 
                for their response before proceeding with this request.</b-alert>
            </b-col>
        </b-row>
                        
        <div v-if="!isUnderReview">

            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="06" :requestId="request.id"
                        v-if="!request.audit.requiresReview"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>
            <b-form @submit.stop.prevent="onSubmit">
              <div v-if="request.positionClassificationValue.code === 'U'">
              <b-row>
                <b-col cols="12" lg="6">
                  <BaseSelector v-model="unclassifiedType"
                                :v="$v.unclassifiedType"
                                slug="auditUnclassifiedType"
                                label="Unclassified Type"
                                :options=unclassifiedTypeOptions />
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="6">
                  <BaseTextInput v-if="unclassifiedType === 'Other Uncl - 43A.08, 1a'" v-model="otherUnclassifiedType"
                                 :v="$v.otherUnclassifiedType"
                                 slug="auditOtherUnclassifiedType"
                                 label="Other Statutory"/>
                </b-col>
              </b-row>
              </div>
                <b-row>
                    <b-col>
                    <BaseSwitchInput v-model="needsAudit"
                                    :v="$v.needsAudit"
                                    label="Is Audit Needed?"
                                    :disabled="isUnderReview"
                                    tip=""/>
                    </b-col>
                </b-row>

                <b-row v-if="needsAudit">
                    <b-col>
                        <BaseClassificationSelector v-model="auditFinalClassification"
                            :v="$v.auditFinalClassification"
                            slug="classification"
                            label="Final Classification"
                            sr="Search for Final Classification"/>
                    </b-col>

                    <b-col>
                        <BaseTextInput v-model="request.audit.auditFinalClassOption" 
                            :v="$v.request.audit.auditFinalClassOption"
                            slug="classOption"
                            label="Final Class Option"/>
                    </b-col>

                    <b-col>
                        <BaseTextInput v-model="request.audit.jobCode" 
                            :v="$v.request.audit.jobCode"
                            slug="jobCode"
                            label="Job Code"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <BaseParagraphInput v-model="request.audit.auditComments"
                            :v="$v.request.audit.auditComments" 
                            slug="auditComments"
                            label="Internal Comments"/>
                    </b-col>
                </b-row>
                
                <div> 
                <b-button type="button" variant="primary" @click="onSubmitForReview"
                    v-if="request.audit.requiresReview == null && needsAudit">Submit Audit for Review</b-button>
                <b-button type="button" variant="primary" @click="onSubmitNoReview"
                    v-if="request.audit.requiresReview == null && !needsAudit">Complete Audit</b-button>
                <b-button type="button" variant="primary" @click="onSubmitReviewApproved"
                    v-if="request.audit.requiresReview === true">Approve Audit</b-button>
                <b-button type="button" variant="outline-primary" @click="onSubmitReviewReturn"
                    v-if="request.audit.requiresReview === true">Return Audit to Staffing Specialist</b-button> 
                <b-button type="button" variant="outline-primary" @click="save">Save</b-button>               
                </div>
            </b-form>
        </div>
    </div>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric, requiredIf } from 'vuelidate/lib/validators'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'
import _ from "lodash"
import {roleService} from "@/mixins/roleService";


export default {
    components: {
        LifecycleCheckList
    },
    props: {
        request: Object
    },
    mixins: [
      roleService
    ],
    data() {
        return {
            checklistComplete: false,
            needsAudit: false,
            saveOnly: false,
            unclassifiedType: '',
            otherUnclassifiedType: null,
            unclassifiedTypeOptions:[
              { value: 'Temp Uncl - 43A.08, 2a', text: 'Temp Uncl - 43A.08, 2a' },
              { value: 'Academic uncl - 43A.08, 1/(9)', text: 'Academic uncl - 43A.08, 1/(9)' },
              { value: 'Student wkr - 43A.08, 1(15)', text: 'Student wkr - 43A.08, 1(15)' },
              { value: 'Other Uncl - 43A.08, 1a', text: 'Other Uncl - 43A.08, 1a' },
            ],
        }
    },
     validations: {
         checklistComplete: { checked: value => value === true },
         needsAudit: { required },
         unclassifiedType: {
           required: requiredIf(function() {
              return this.request.positionClassificationValue.code === 'U'
           }),
           maxLength: maxLength(30)},
         otherUnclassifiedType: {
           required: requiredIf(function() {
             return this.request.positionClassificationValue.code === 'U' && this.unclassifiedType === 'Other Uncl - 43A.08, 1a'
           }),
           maxLength: maxLength(50)},
         auditFinalClassification: { 
             required: requiredIf(function() {
                return this.auditNeeded
            }) 
         },
         request: {
             audit: {

                 auditNeeded: { required },
                 auditFinalClassification: { required: requiredIf(function() {
                        return this.auditNeeded
                    }) },
                 auditFinalClassOption: { required: false, maxLength: maxLength(60) },
                 jobCode: { required: false, maxLength: maxLength(25) },
                 auditComments: { required: false, maxLength: maxLength(4000) }
             }
         }
     },
    computed: {       
        isUnderReview: function() {
            return ((!this.isAudit()) &&
                this.request.audit.requiresReview === true)
        } 
    },
    created() {
        if (this.request.audit.requiresReview === true) {
            this.checklistComplete = true
        }

        this.needsAudit = this.request.audit.auditNeeded
        this.auditFinalClassification = this.request.audit.auditFinalClassification
        this.unclassifiedType = this.request.audit.unclassifiedType
        this.otherUnclassifiedType = this.request.audit.otherUnclassifiedType

    },

    mounted: function() {
        this.autosave()
    },
    beforeDestroy() {

       clearInterval(this.autosave_id)
    },

    methods: {
        updateChecklistStatus(b) {
            this.checklistComplete = b
        },

        onSubmitForReview() {
            this.$refs.checklist.emitCheckListStatus()
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$nextTick(() => {
                    document.getElementById('form-container').scrollIntoView()
                })
                return
            }

            this.request.audit.auditNeeded = this.needsAudit
            this.request.audit.auditFinalClassification = this.auditFinalClassification
            this.request.audit.unclassifiedType = this.unclassifiedType
            this.request.audit.otherUnclassifiedType = this.otherUnclassifiedType

            let payload = {
                requestId: this.request.id,
                ...this.request.audit
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/auditReview`, payload)
                .then(response => { 
                    this.showRootToast("Audit Review Submitted", "The audit has been submitted for review by HRM Supervisor.", "success")
                     this.$router.push('/home')
                })
        },

        autosave() {          
            this.autosave_id = setInterval(() => {
                this.save()
            }, 300000);
        },

        save() {
            this.saveOnly = true
            this.onSubmitNoReview()
            this.saveOnly = false
        },

        nextLifecycle() {
            let result = '07'

            // Reallocations, Appeal, and Work out of Class (03, 06, 07) skip directly to salary review (11)
            if (_.includes(['03', '06', '07'], this.request.requestTypeValue.code)) { 
                result = '11'
            }

            return result
        },

        onSubmitNoReview() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            this.request.audit.auditNeeded = this.needsAudit  
            this.request.audit.auditFinalClassification = this.auditFinalClassification
            this.request.audit.advanceNextLifecycle = !this.saveOnly
            this.request.audit.unclassifiedType = this.unclassifiedType
            this.request.audit.otherUnclassifiedType = this.otherUnclassifiedType

            let payload = {
                requestId: this.request.id,
                nextLifecycle: this.nextLifecycle(),
                ...this.request.audit
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/audit`, payload)
                .then(response => { 
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    if (payload.advanceNextLifecycle === true) {
                        this.$router.push('/home')
                    } 
                })                  
        },

        onSubmitReviewApproved() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$nextTick(() => {
                    document.getElementById('form-container').scrollIntoView()
                })
                return
            }

            this.request.audit.auditNeeded = this.needsAudit
            this.request.audit.auditFinalClassification = this.auditFinalClassification
            this.request.audit.unclassifiedType = this.unclassifiedType
            this.request.audit.otherUnclassifiedType = this.otherUnclassifiedType

            let payload = {
                requestId: this.request.id,
                advanceNextLifecycle: true,
                nextLifecycle: this.nextLifecycle(),
                ...this.request.audit
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/auditReviewApproved`, payload)
                  .then(response => { 
                    this.showRootToast("Audit Review Updated", "The Audit Review status has been updated.", "success")
                     this.$router.push('/home')
                  })
                  
        },

        onSubmitReviewReturn() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$nextTick(() => {
                    document.getElementById('form-container').scrollIntoView()
                })
                return
            }

            this.request.audit.auditNeeded = this.needsAudit            
            this.request.audit.auditFinalClassification = this.auditFinalClassification
            this.request.audit.unclassifiedType = this.unclassifiedType
            this.request.audit.otherUnclassifiedType = this.otherUnclassifiedType

            let payload = {
                requestId: this.request.id,
                ...this.request.audit
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/auditReviewReturned`, payload)
                  .then(response => { 
                    this.showRootToast("Audit Review Updated", "The Audit Review status has been updated.", "success")
                     this.$router.push('/home')
                  })
                  
        },

        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })
        },

    }   
}
</script>